import { render } from "./lowversion.vue?vue&type=template&id=2671018e&scoped=true&ts=true"
import script from "./lowversion.vue?vue&type=script&lang=ts"
export * from "./lowversion.vue?vue&type=script&lang=ts"

import "./lowversion.vue?vue&type=style&index=0&id=2671018e&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2671018e"]])

export default __exports__